import React, { FC, ReactElement, useMemo } from 'react';
import { NotificationEntity } from 'app/interfaces/entity';
import { NotificationType } from '@okletsplay/core';
import { BaseNotificationTile } from '../BaseNotificationTile';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';
import RedeemIcon from '@mui/icons-material/Redeem';
import { Box } from '@mui/material';

interface BalanceNotificationTileProps {
  notification: NotificationEntity;
  onClick?: (notification: NotificationEntity) => void;
}

export const BalanceNotificationTile: FC<BalanceNotificationTileProps> = ({
  notification,
  onClick = () => null,
}) => {
  const notificationTemplate: Partial<Record<NotificationType, ReactElement | null>> =
    useMemo(() => {
      return {
        [NotificationType.BalanceAutoSwapSuccessful]: (
          <BaseNotificationTile
            image={<SwapVertIcon />}
            message={notification.message ?? 'Auto swap successful!'}
            date={notification.createdAt}
            seen={notification.seen}
          />
        ),
        [NotificationType.BalanceAutoSwapFailed]: (
          <BaseNotificationTile
            image={<MobiledataOffIcon />}
            message={notification.message ?? 'Auto swap failed!'}
            date={notification.createdAt}
            seen={notification.seen}
          />
        ),
        [NotificationType.AffiliateProgramCommissionPayoutComplete]: (
          <BaseNotificationTile
            image={<RedeemIcon />}
            message={notification.message ?? 'Received affiliate commission!'}
            date={notification.createdAt}
            seen={notification.seen}
          />
        ),
      };
    }, [notification.createdAt, notification.message, notification.seen]);

  return <Box onClick={() => onClick(notification)}>{notificationTemplate[notification.type]}</Box>;
};
